"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importStar(require("react"));

var Row_1 = require("./Row");

var Column_1 = require("./Column");

var Image = styled_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var Thumbnail = styled_1.default.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var Button = styled_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  border: none;\n  outline: none;\n"], ["\n  width: 100%;\n  border: none;\n  outline: none;\n"])));

exports.Images = function (_a) {
  var tenant = _a.tenant,
      images = _a.images;

  var _b = react_1.useState(images[0]),
      selected = _b[0],
      setSelected = _b[1];

  return react_1.default.createElement("div", null, react_1.default.createElement(Image, {
    src: "https://media.nimles.com/file/" + tenant + "/" + selected + "?width=860"
  }), react_1.default.createElement(Row_1.Row, {
    wrap: true
  }, images.filter(function (i) {
    return i !== selected;
  }).map(function (id) {
    return react_1.default.createElement(Column_1.Column, {
      width: 25
    }, react_1.default.createElement(Button, {
      onClick: function onClick() {
        return setSelected(id);
      }
    }, react_1.default.createElement(Thumbnail, {
      src: "https://media.nimles.com/file/" + tenant + "/" + selected + "?width=200"
    })));
  })));
};

var templateObject_1, templateObject_2, templateObject_3;